const config = {
  appName: 'Rockite',
  persistencePrefix: 'RockitePrefs',
  urls: {
    web: 'https://rockite.pages.dev',
    github: 'https://github.com/psyirius/rockite',
    issues: 'https://github.com/psyirius/rockite/issues',
    releases: 'https://github.com/psyirius/rockite/releases',
    desktop: 'https://github.com/psyirius/rockite/releases',
    webext: {
      chrome: 'https://chrome.google.com/webstore/detail/ajlfbfcpbnkjhmbpbdagjfnlmgcikmgg',
      // TODO: Update this link once the extension is published
      // edge: 'https://github.com/psyirius/Rockite/releases',
      // TODO: Update this link once the extension is published
      // firefox: 'https://github.com/psyirius/Rockite/releases',
    },
  },
}

export default config
